@if (!formReadonlyMode) {
    <mat-form-field class="mxs-input"
                    [formGroup]="form"
                    [ngClass]="{'hidden': hidden}"
                    [matTooltip]="getValidationHint() | translate"
                    [matTooltipShowDelay]="500"
                    [matTooltipClass]="'mxs-error-ttip'">
        <mat-label>{{getLabel() | translate}}</mat-label>
        <mat-select [formControlName]="name"
                    [id]="name"
                    hideSingleSelectionIndicator="true"
                    [errorStateMatcher]=errorService
                    (closed)="searchOption.value=null"
                    (opened)="searchOption.focus()"
                    [required]="required">
            <div class="search-input-wrapper" [ngClass]="{'hidden': !needSearch}">
                <mat-form-field class="mxs-input mat-input-field" >
                    <input matInput #searchOption/>
                </mat-form-field>
            </div>
            @if (!required) {
                <mat-option>{{'None' | translate}}</mat-option>
            }
            @for (opt of filteredOptions | filter:'value': searchOption.value; track opt.key) {
                <mat-option [value]="opt.key">
                    {{opt.value}}
                </mat-option>
            }
        </mat-select>
        @if (isDisplayed() && !required) {
            <button matSuffix mat-icon-button type="button" aria-label="Clear"
                    (click)="resetValue($event)">
                <mat-icon>clear</mat-icon>
            </button>
        }
        <mat-hint>{{getHint() | translate}}</mat-hint>
        @for (error of getValidationMessages(true); track $index) {
            <mat-error>
                {{getError(error) | translate}}
            </mat-error>
        }
    </mat-form-field>
} @else {
    <mat-list-item class="mxs-readonly"
                   [ngClass]="{'hidden': hidden}">
        <div class="mxs-readonly_label">{{getLabel() | translate}}</div>
        <div class="mxs-readonly_input">
            {{getDisplayValue(getOptionValueByKey(form.controls[name].value))}}
        </div>
    </mat-list-item>
}
